import React, { useState, useEffect } from 'react';

import * as S from './styles';

interface PasswordProtectedRouteProps {
  children: React.ReactNode;
  password: string;
}

const SESSION_STORAGE_KEY = 'withlove_auth';

export default function PasswordProtectedRoute({
  children,
  password,
}: PasswordProtectedRouteProps) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [inputPassword, setInputPassword] = useState('');
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedAuth = sessionStorage.getItem(SESSION_STORAGE_KEY);

    if (storedAuth === password) {
      setIsAuthenticated(true);
    }

    setIsLoading(false);
  }, [password]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (inputPassword === password) {
      sessionStorage.setItem(SESSION_STORAGE_KEY, password);
      setIsAuthenticated(true);
      setShowError(false);
    } else {
      setShowError(true);
      setInputPassword('');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputPassword(e.target.value);

    if (showError) {
      setShowError(false);
    }
  };

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return (
      <S.PasswordFormContainer>
        <S.PasswordFormContent>
          <S.Logo alt="GivingSide" src="/logo-white.png" />
          <S.FormCard>
            <S.Title>Protected Page</S.Title>
            <S.Description>
              Please enter the password to access this page.
            </S.Description>

            {showError && (
              <S.ErrorMessage>
                Incorrect password. Please try again.
              </S.ErrorMessage>
            )}

            <form onSubmit={handleSubmit}>
              <S.PasswordInput
                autoFocus
                placeholder="Enter password"
                type="password"
                value={inputPassword}
                onChange={handleInputChange}
              />
              <S.SubmitButton type="submit">Access Page</S.SubmitButton>
            </form>
          </S.FormCard>
        </S.PasswordFormContent>
      </S.PasswordFormContainer>
    );
  }

  return <>{children}</>;
}
